// extracted by mini-css-extract-plugin
module.exports = {"h1":"BaseElements_h1__evdhC","h2":"BaseElements_h2__uksPG","h3":"BaseElements_h3__1ld05","p":"BaseElements_p__2uAOM","footnote":"BaseElements_footnote__2qr5H"};